import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { APP_VERSION, CANCEL_REQUEST } from "constants/index";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Input,
  InputNumber,
  Layout,
  Form,
} from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import emptyImg from "../assets/img/empty.svg";
import NoteService from "services/note.service";
import { setUserWallet } from "redux/actions/auth.action";
import axios from "axios";

const { Header, Content, Footer } = Layout;
const initialValues = {
  amount: null,
};

const CreateItem = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onClear = () => {
    form.setFieldsValue(initialValues);
  };

  const handleDeposit = (e) => {
    form
      .validateFields()
      .then((params) => {
        console.log(params);
        setIsLoading(true);
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        NoteService.deposit(params, source).then(
          (request) => {
            dispatch(setUserWallet(request.user))
              .then(() => {
                message.info("Money successfully deposited", 5);
                onClear();
              })
              .catch((err) => {
                setIsLoading(false);
              });
          },
          (error) => {
            if (error && error.response.data && error.response.data.errors) {
              message.error(error.response.data.errors.join(". "), 5);
            } else if (error && error.message !== CANCEL_REQUEST) {
              message.error("API got error, please contact us.", 5);
            }
            console.log(error);
            setIsLoading(false);
            return Promise.reject();
          }
        );
      })
      .catch((e) => {
        message.warning("Please check the form validation");
      });
  };

  return (
    <>
      <Content>
        <Row gutter={16} justify="space-around" align="middle">
          <Col span={24}>
            <Form layout="vertical" initialValues={initialValues} form={form}>
              <Card title="Deposit" bordered={true}>
                <Space direction="vertical" size="very-small">
                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[{ required: true, message: "Amount is required" }]}
                  >
                    <InputNumber
                      style={{ width: 200 }}
                      min="0.01"
                      step="0.01"
                      placeholder="Amount"
                      allowClear
                    />
                  </Form.Item>
                  <div>
                    <Button
                      onClick={() => props.history.push("/main/overview")}
                      style={{ marginRight: 8 }}
                    >
                      Cancel
                    </Button>
                    <Button onClick={(e) => handleDeposit(e)} type="primary">
                      Deposit
                    </Button>
                  </div>
                </Space>
              </Card>
            </Form>
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default CreateItem;
